module.exports = __webpack_public_path__ + "static/media/money-check-edit-alt.6704d5b2.svg";